import React from "react";

import { FieldError } from "./PositionFormFields";
import type { PositionFormik, ShiftField } from "./positionForm.types";

export type ErrorRenderer = (field: ShiftField) => React.ReactNode;

/** Errors of the edit form, where the shift fields live on the root (`values.timeIn`). */
export const formErrorFor =
  ({ touched, errors }: Pick<PositionFormik, "touched" | "errors">): ErrorRenderer =>
  (field) => <FieldError show={touched?.[field]} message={errors?.[field]} />;

/** Errors of one add-flow row (`values.positionTimeInfo[rowIndex].timeIn`). */
export const rowErrorFor =
  ({ touched, errors }: Pick<PositionFormik, "touched" | "errors">, rowIndex: number): ErrorRenderer =>
  (field) => {
    const rowTouched = touched?.positionTimeInfo?.[rowIndex];
    const rowErrors = errors?.positionTimeInfo?.[rowIndex];
    return (
      <FieldError
        show={rowTouched?.[field]}
        message={typeof rowErrors === "object" ? rowErrors?.[field] : undefined}
      />
    );
  };
